// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"a36c4c07","596":"f9035b3c","787":"ecba751e"}[chunkId] + ".chunk.js";
};